import React from "react";

// language tokens for the ui package go here
export interface UILocale {
  dialog: {
    cancel: string;
    save: string;
    sessionTimeout: {
      headline: string;
      body: string;
      confirmButton: string;
      dismissButton: string;
    };
    networkError: {
      headline: string;
      body: string;
      showDetails: string;
      confirmButton: string;
    };
    genericError: {
      headline: string;
      body: string;
      showDetails: string;
      confirmButton: string;
    };
  };
}

// defaults
export const UILocaleDefaults: UILocale = {
  dialog: {
    cancel: "Cancel",
    save: "Save",
    sessionTimeout: {
      headline: "Session Timeout",
      body: "Your session is about to expire. Do you want to stay logged in?",
      confirmButton: "Stay Logged In",
      dismissButton: "Log Out",
    },
    networkError: {
      headline: "Network Error",
      body: "There was a problem connecting to the network. Please check your connection and try again.",
      showDetails: "Show technical details",
      confirmButton: "Retry",
    },
    genericError: {
      headline: "Something went wrong",
      body: "An unexpected error occurred. Please try again later. If this error continues, please contact your library staff.",
      confirmButton: "Try again",
      showDetails: "Show technical details",
    },
  },
};

const UILocaleContext = React.createContext<UILocale>(null);

export const UILocaleProvider: React.FC<{
  locale: UILocale;
  children: React.ReactNode;
}> = ({ locale, children }) => {
  return (
    <UILocaleContext.Provider value={locale}>
      {children}
    </UILocaleContext.Provider>
  );
};

export function useUILocale(): UILocale {
  const value = React.useContext(UILocaleContext);
  if (!value) {
    throw new Error("UILocaleProvider is missing.");
  }
  return value;
}
